import VehicleFormPage from "./VehicleFormPage";

export default function UpdateVehicle() {
  return <VehicleFormPage mode="update" />;
}
